export default __webpack_public_path__ + "static/media/feature-a-3.fc8e9fe1.jpg";